import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';

@Injectable({
    providedIn: 'root'
})
export class PopupService {
    public showPopup$: Subject<boolean> = new Subject<boolean>();
    public elRef: any = null;

    private showPopup: boolean = false;

    constructor() {}

    public openPopup(view: any): void {
        if (!this.showPopup) {
            this.showPopup$.next(true);
            this.showPopup = true;
            this.elRef = view;
        }
    }

    public closePopup(): void {
        if (this.showPopup) {
            this.showPopup$.next(false);
            this.showPopup = false;
            this.elRef = null;
        }
    }

    public getPopupView(): any {
        return this.elRef;
    }
}
